// src/components/Dashboard/UnfulfillableProductsPanel.js
import React from 'react';

const UnfulfillableProductsPanel = ({ unfulfillableProductStats }) => {
	return (
		<div className="p-5 pt-0">
			<div className="overflow-x-auto">
				{unfulfillableProductStats ? (
					<table className="min-w-full divide-y divide-gray-200">
						<thead className="bg-gray-50">
						<tr>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								SKU
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Name
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Unfulfillable Count
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Affected Orders
							</th>
							<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Missing Parts
							</th>
						</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
						{Object.values(unfulfillableProductStats).map((product, index) => (
							<tr key={index} className="hover:bg-gray-50">
								<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
									{product.sku}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
									{product.name}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-red-500 font-medium">
									{product.unfulfillable_count}
								</td>
								<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
									<div className="flex flex-wrap text-wrap max-w-[210px]">
										{Object.values(product.affected_orders).join(', ')}
									</div>
								</td>
								<td className="px-6 py-4 text-sm text-gray-500">
									{Object.entries(product.total_deficit).map(([part, deficit]) => (
										<div key={part} className="flex items-center">
											<span className="inline-block h-2 w-2 rounded-full bg-red-400 mr-2"></span>
											{part}: <span className="text-red-500 font-medium ml-1">-{deficit}</span>
										</div>
									))}
								</td>
							</tr>
						))}
						</tbody>
					</table>
				) : (
					 <p className="text-gray-500 py-4">No unfulfillable products at this time.</p>
				 )}
			</div>
		</div>
	);
};

export default UnfulfillableProductsPanel;
